import { LAYOUTS, } from '@voltmoney/types';
import { AspectRatioToken, ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, FontFamilyTokens, FontSizeTokens, ImageSizeTokens, InputStateToken, InputTypeToken, KeyboardTypeToken, SizeTypeTokens, StackAlignItems, StackJustifyContent, StackType, StackWidth, TextAlignTokens, TextInputTypeToken, WIDGET, } from '@voltmoney/schema';
import { ROUTE } from '../../routes';
import { ACTION } from './types';
import { changeInput, onApplyNow, onChangeDimension, onSelectPortfolio, toggleCTA } from './actions';
import { RegexConfig } from "../../configs/config";
import sharedPropsService from "../../SharedPropsService";
import { config } from "../../configs/api";
const MarketingLeadsCheckMFOptionData = [
    { label: 'Yes, I have mutual funds', value: 'Yes' },
    { label: 'No, I don’t have mutual funds', value: 'No' },
];
const MarketingLeadsPortfolioOptionData = [
    { label: '₹10K - ₹50K', value: "AMOUNT_10K_50K" /* ASSET_DETAILS_VALUE.AMOUNT_10K_50K */ },
    { label: '₹50K - ₹2L', value: "AMOUNT_50K_2L" /* ASSET_DETAILS_VALUE.AMOUNT_50K_2L */ },
    { label: '₹2L - ₹10L', value: "AMOUNT_2L_10L" /* ASSET_DETAILS_VALUE.AMOUNT_2L_10L */ },
    { label: 'More than ₹10L', value: "AMOUNT_ABOVE_10L" /* ASSET_DETAILS_VALUE.AMOUNT_ABOVE_10L */ },
];
export const template = async (haveMutualFunds, name, phone, portfolioValue) => ({
    layout: {
        id: ROUTE.MARKETING_LEAD,
        type: LAYOUTS.LIST,
        widgets: [
            { id: 'MarketingLeadsRootStack', type: WIDGET.STACK },
        ],
    },
    datastore: {
        MarketingLeadsRootStack: {
            width: StackWidth.MATCH_PARENT,
            widgetItems: [
                { id: 'MarketingLeadsT1', type: WIDGET.TEXT },
                { id: 'MarketingLeadsSpace0', type: WIDGET.SPACE },
                { id: 'MarketingLeadsT2', type: WIDGET.TEXT },
                { id: 'MarketingLeadsSpace1', type: WIDGET.SPACE },
                { id: 'MarketingLeadsT3', type: WIDGET.TEXT },
                { id: 'MarketingLeadsT4', type: WIDGET.TEXT },
                { id: 'MarketingLeadsSpace2', type: WIDGET.SPACE },
                { id: 'MarketingLeadsCheckMFOption', type: WIDGET.DROPDOWN_INPUT },
                { id: 'MarketingLeadsSpace3', type: WIDGET.SPACE },
                { id: 'MarketingLeadsYesContainer', type: WIDGET.STACK },
                { id: 'MarketingLeadsNoContainer', type: WIDGET.STACK },
                { id: 'MarketingLeadsBottomParentBanner', type: WIDGET.STACK },
            ],
            dimensionAction: {
                routeId: ROUTE.MARKETING_LEAD,
                type: ACTION.GET_DIMENSION,
                payload: {}
            }
        },
        MarketingLeadsBottomParentBanner: {
            type: StackType.column,
            width: StackWidth.MATCH_PARENT,
            widgetItems: [
                { id: 'MarketingLeadsBottomBanner', type: WIDGET.STACK },
                { id: 'MarketingLeadsSpace4', type: WIDGET.SPACE },
                { id: 'ApplyNowBtn', type: WIDGET.BUTTON },
                { id: 'MarketingLeadsSpace5', type: WIDGET.SPACE },
            ]
        },
        MarketingLeadsNoContainer: {
            type: StackType.column,
            width: StackWidth.MATCH_PARENT,
            hide: true,
            alignItems: StackAlignItems.center,
            widgetItems: [
                { id: 'MarketingLeadsNoContainerSpace0', type: WIDGET.SPACE },
                { id: 'MarketingLeadsNoContainerIcon1', type: WIDGET.IMAGE },
                { id: 'MarketingLeadsNoContainerSpace1', type: WIDGET.SPACE },
                { id: 'MarketingLeadsNoContainerT1', type: WIDGET.TEXT },
                { id: 'MarketingLeadsNoContainerSpace3', type: WIDGET.SPACE },
                { id: 'MarketingLeadsNoContainerT2', type: WIDGET.TEXT },
                { id: 'MarketingLeadsNoContainerSpace4', type: WIDGET.SPACE },
            ]
        },
        MarketingLeadsNoContainerIcon1: {
            uri: 'https://volt-images.s3.ap-south-1.amazonaws.com/no_mutualfunds.png',
            aspectRatio: AspectRatioToken.A1_1,
            width: 99,
            height: 99
        },
        MarketingLeadsNoContainerT1: {
            label: 'We’re currently available to mutual fund investors only',
            fontFamily: FontFamilyTokens.Poppins,
            fontWeight: '600',
            fontSize: FontSizeTokens.MD,
            lineHeight: 24,
            color: ColorTokens.Grey_Night,
            textAlign: TextAlignTokens.center
        },
        MarketingLeadsNoContainerT2: {
            label: 'We’re constantly working on expanding our offering to more customers. Please try again later.',
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: '400',
            fontSize: FontSizeTokens.MD,
            lineHeight: 24,
            color: ColorTokens.Grey_Charcoal,
            textAlign: TextAlignTokens.center
        },
        MarketingLeadsYesContainer: {
            type: StackType.column,
            width: StackWidth.MATCH_PARENT,
            hide: haveMutualFunds !== 'Yes',
            widgetItems: [
                { id: 'MarketingLeadsYesContainer_fullName', type: WIDGET.INPUT },
                { id: 'MarketingLeadsYesContainerSpace0', type: WIDGET.SPACE },
                { id: 'MarketingLeadsYesContainer_phoneNumber', type: WIDGET.INPUT },
                { id: 'MarketingLeadsYesContainerSpace1', type: WIDGET.SPACE },
                { id: 'MarketingLeadsYesContainer_selectPorfolioValue', type: WIDGET.DROPDOWN_INPUT },
                { id: 'MarketingLeadsYesContainerSpace3', type: WIDGET.SPACE },
                { id: 'MarketingLeadsYesContainerSpaceStack1', type: WIDGET.STACK },
            ]
        },
        MarketingLeadsYesContainerSpaceStack1: {
            width: StackWidth.MATCH_PARENT,
            hide: true,
            widgetItems: [
                { id: 'MarketingLeadsYesContainerSpaceStackSpace1', type: WIDGET.SPACE },
                { id: 'MarketingLeadsYesContainerSpaceStackSpace2', type: WIDGET.SPACE },
            ]
        },
        MarketingLeadsYesContainerSpaceStackSpace1: {
            size: SizeTypeTokens.SIZE72
        },
        MarketingLeadsYesContainerSpaceStackSpace2: {
            size: SizeTypeTokens.SIZE18
        },
        MarketingLeadsYesContainer_fullName: {
            width: TextInputTypeToken.FULL,
            isFocus: false,
            title: 'Enter full name *',
            fontFamily: FontFamilyTokens.Inter,
            fontSize: FontSizeTokens.MD,
            lineHeight: 24,
            fontWeight: '400',
            placeholder: 'Enter full name',
            value: `${name}`,
            color: ColorTokens.Grey_Night,
            type: InputTypeToken.DEFAULT,
            state: InputStateToken.DEFAULT,
            action: {
                type: ACTION.INPUT_NAME,
                payload: {
                    value: '',
                    widgetID: 'MarketingLeadsYesContainer_fullName',
                },
                routeId: ROUTE.MARKETING_LEAD,
            },
        },
        MarketingLeadsYesContainer_phoneNumber: {
            width: TextInputTypeToken.FULL,
            isFocus: false,
            onlyNumeric: true,
            regex: RegexConfig.MOBILE,
            title: 'Enter mobile number *',
            fontFamily: FontFamilyTokens.Inter,
            charLimit: 10,
            fontSize: FontSizeTokens.MD,
            keyboardType: KeyboardTypeToken.numberPad,
            lineHeight: 24,
            fontWeight: '400',
            placeholder: 'Enter mobile number',
            value: `${phone.slice(3)}`,
            color: ColorTokens.Grey_Night,
            type: InputTypeToken.MOBILE,
            state: InputStateToken.DEFAULT,
            caption: { error: "Enter a 10 digit mobile number" },
            action: {
                type: ACTION.INPUT_PHONE,
                payload: {
                    value: '',
                    widgetID: 'MarketingLeadsYesContainer_phoneNumber',
                },
                routeId: ROUTE.MARKETING_LEAD,
            },
            errorAction: {
                type: ACTION.DISABLE_CONTINUE,
                routeId: ROUTE.MARKETING_LEAD,
                payload: { value: false, widgetID: "ApplyNowBtn" },
            },
            successAction: {
                type: ACTION.ENABLE_CONTINUE,
                routeId: ROUTE.MARKETING_LEAD,
                payload: { value: true, widgetID: "ApplyNowBtn" },
            },
        },
        MarketingLeadsYesContainer_selectPorfolioValue: {
            label: 'What is your Mutual Funds Value? *',
            data: MarketingLeadsPortfolioOptionData,
            width: '100%',
            value: `${portfolioValue}`,
            openAction: {
                type: ACTION.SELECT_PORFOLIO,
                payload: {
                    value: true
                },
                routeId: ROUTE.MARKETING_LEAD,
            },
            closeAction: {
                type: ACTION.SELECT_PORFOLIO,
                payload: {
                    value: false
                },
                routeId: ROUTE.MARKETING_LEAD,
            },
            action: {
                type: ACTION.SELECT_HAVE_NOT_HAVE_MF,
                payload: {
                    value: null,
                    widgetID: 'MarketingLeadsYesContainer_selectPorfolioValue',
                },
                routeId: ROUTE.MARKETING_LEAD,
            },
        },
        ApplyNowBtn: {
            type: ButtonTypeTokens.LargeOutline,
            label: 'Check Free Loan Limit',
            width: ButtonWidthTypeToken.FULL,
            action: {
                type: ACTION.APPLY_NOW,
                payload: {
                    value: "",
                    widgetId: "continue",
                    isResend: false,
                },
                routeId: ROUTE.MARKETING_LEAD,
            },
        },
        MarketingLeadsBottomBanner: {
            width: StackWidth.MATCH_PARENT,
            type: StackType.row,
            justifyContent: StackJustifyContent.center,
            alignItems: StackAlignItems.center,
            widgetItems: [
                { id: 'MarketingLeadsBottomBannerIcon', type: WIDGET.IMAGE },
                { id: 'MarketingLeadsBottomBannerT1', type: WIDGET.TEXT }
            ]
        },
        MarketingLeadsBottomBannerIcon: {
            uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/goldenThunder3x.png',
            aspectRatio: AspectRatioToken.A1_1,
            size: ImageSizeTokens.XXS,
        },
        MarketingLeadsBottomBannerT1: {
            label: ' It does not impact CIBIL score  ',
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: '400',
            fontSize: FontSizeTokens.XXS,
            lineHeight: 16,
            color: ColorTokens.Grey_Night,
        },
        MarketingLeadsCheckMFOption: {
            label: 'Select option *',
            data: MarketingLeadsCheckMFOptionData,
            width: '100%',
            hide: haveMutualFunds === 'Yes' ? true : false,
            value: `${haveMutualFunds}`,
            action: {
                type: ACTION.SELECT_HAVE_NOT_HAVE_MF,
                payload: {
                    value: null,
                    widgetID: 'MarketingLeadsCheckMFOption',
                },
                routeId: ROUTE.MARKETING_LEAD,
            },
        },
        MarketingLeadsT1: {
            label: 'Check eligibility in 5 mins',
            fontFamily: FontFamilyTokens.Poppins,
            fontWeight: '700',
            fontSize: FontSizeTokens.LG,
            lineHeight: 24,
            color: ColorTokens.Grey_Night,
        },
        MarketingLeadsT2: {
            label: 'Do you have mutual funds?',
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: '500',
            fontSize: FontSizeTokens.SM,
            lineHeight: 24,
            color: ColorTokens.Grey_Night,
        },
        MarketingLeadsT3: {
            label: 'Eligible amount is based on mutual fund portfolio.',
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: '400',
            fontSize: FontSizeTokens.XS,
            lineHeight: 18,
            color: ColorTokens.System_Warning,
        },
        MarketingLeadsT4: {
            label: 'We do not provide personal loans.',
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: '700',
            fontSize: FontSizeTokens.XS,
            lineHeight: 18,
            color: ColorTokens.System_Warning,
        },
        MarketingLeadsSpace0: {
            size: SizeTypeTokens.XL
        },
        MarketingLeadsSpace1: {
            size: SizeTypeTokens.SM
        },
        MarketingLeadsSpace2: {
            size: SizeTypeTokens.XL
        },
        MarketingLeadsSpace3: {
            size: SizeTypeTokens.XXXL
        },
        MarketingLeadsSpace4: {
            size: SizeTypeTokens.MD
        },
        MarketingLeadsSpace5: {
            size: SizeTypeTokens.XXL
        },
        MarketingLeadsYesContainerSpace0: {
            size: SizeTypeTokens.XXXL
        },
        MarketingLeadsYesContainerSpace1: {
            size: SizeTypeTokens.XXXL
        },
        MarketingLeadsYesContainerSpace3: {
            size: SizeTypeTokens.XXXL
        },
        MarketingLeadsNoContainerSpace0: {
            size: SizeTypeTokens.XXXL
        },
        MarketingLeadsNoContainerSpace1: {
            size: SizeTypeTokens.XL
        },
        MarketingLeadsNoContainerSpace2: {
            size: SizeTypeTokens.MD
        },
        MarketingLeadsNoContainerSpace3: {
            size: SizeTypeTokens.MD
        },
        MarketingLeadsNoContainerSpace4: {
            size: SizeTypeTokens.MD
        },
    },
});
export const MarketingLeadsMF = {
    onLoad: async ({ instrumentTrack, initializeAmplitude }) => {
        initializeAmplitude('', config.AMPLITUDE_CONFIG);
        const leadDetails = await sharedPropsService.getMarketingLeadsData();
        const haveMutualFunds = `${leadDetails?.haveMutualFunds ? leadDetails.haveMutualFunds : ''}`;
        const name = `${leadDetails?.fullName ? leadDetails.fullName : ''}`;
        const phone = `${leadDetails?.phoneNumber ? leadDetails?.phoneNumber : ''}`;
        const portfolioValue = `${leadDetails.assetDetail ? leadDetails.assetDetail : ''}`;
        instrumentTrack('SIGNUP_PAGE_VIEWED', { type: 'lead_form' });
        return Promise.resolve(template(haveMutualFunds, name, phone, portfolioValue));
    },
    actions: {
        [ACTION.SELECT_HAVE_NOT_HAVE_MF]: changeInput,
        [ACTION.INPUT_PHONE]: changeInput,
        [ACTION.INPUT_NAME]: changeInput,
        [ACTION.SELECT_PORTFOLIO_VALUE]: changeInput,
        [ACTION.ENABLE_CONTINUE]: toggleCTA,
        [ACTION.DISABLE_CONTINUE]: toggleCTA,
        [ACTION.APPLY_NOW]: onApplyNow,
        [ACTION.GET_DIMENSION]: onChangeDimension,
        [ACTION.SELECT_PORFOLIO]: onSelectPortfolio,
    },
};
